export default "__VITE_ASSET__CjVvr0Zn__"